import { render, staticRenderFns } from "./AsignacionFiltroPlataforma.vue?vue&type=template&id=692c442d&"
import script from "./AsignacionFiltroPlataforma.vue?vue&type=script&lang=ts&"
export * from "./AsignacionFiltroPlataforma.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports